import React from 'react';
import { BsFillExclamationTriangleFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Box, Flex, Icon, IconButton, Text } from '@chakra-ui/react';

import CertHolderInfoBlock from '../../../../components/CertificateCreationFlow/components/CertHolderInfoBlock';
import InsuredInfoBlock from '../../../../components/CertificateCreationFlow/components/InsuredInfoBlock';
import RequirementBlock from '../../../../components/CertificateCreationFlow/components/RequirementBlock';
import LoadingSpinner from '../../../../components/Spinner';
import { selectCompany, selectInsured, selectJob } from '../../../../redux/modules/agentPortal';

const NoRecordExistsBlock = props => {
  const company = useSelector(selectCompany);
  const job = useSelector(selectJob);
  const insured = useSelector(selectInsured);

  return (
    <Box>
      <RequirementBlock title="Uh Oh">
        <Flex flexBasis="100%" flexFlow="row wrap">
          <Flex flexBasis="5%">
            <IconButton
              aria-label="Error Icon"
              icon={<Icon as={BsFillExclamationTriangleFill} boxSize={6} />}
              variant="textError"
            />
          </Flex>

          <Flex flexBasis="95%">
            <Text>
              It looks like the certificate holder is no longer tracking insurance requirements between this
              insured and project. If you believe you have reached this message in error, please contact the Certificate
              Holder or Insured directly.
            </Text>
          </Flex>
        </Flex>
      </RequirementBlock>

      <Flex flexBasis="100%" flexFlow="row wrap" justifyContent="space-between">
        <Flex flexBasis="48%">
          {(company && job)
            ? (<CertHolderInfoBlock company={company} job={job} />)
            : (<LoadingSpinner />)}
        </Flex>
        <Flex flexBasis="48%">
          {(insured)
            ? (<InsuredInfoBlock insured={insured} requirement={{}} />)
            : (<LoadingSpinner />)}
        </Flex>
      </Flex>
    </Box>
  );
};

export default NoRecordExistsBlock;
